import { render, staticRenderFns } from "./DailyUseSection.vue?vue&type=template&id=84e52bc0&scoped=true"
import script from "./DailyUseSection.vue?vue&type=script&lang=js"
export * from "./DailyUseSection.vue?vue&type=script&lang=js"
import style0 from "./DailyUseSection.vue?vue&type=style&index=0&id=84e52bc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e52bc0",
  null
  
)

export default component.exports